































































































































































import Vue from 'vue';
import config from '../../config/index';
import Validadores from '../../config/validaRut';
import { LoginInterface } from '../../interfaces/Login';
import { Component, Watch } from 'vue-property-decorator';
import router from '../../router';
import HandleErrors from '../../config/handleErrors';
import { constants } from 'fs';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import moment, { Duration } from 'moment';
import { LoadingService } from '@/services/loadingService';

if (process.env.NODE_ENV == 'QA') {
  if (location.host.split('.')[0] == 'qagpstrack') {
    import(`../../css/${'track3'}_login_style.css`);
  } else {
    import(
      `../../css/${
        location.hostname == 'localhost'
          ? 'track3'
          : location.host.split('.')[0].substring(3) == ''
          ? '192'
          : location.host.split('.')[0].substring(3)
      }_login_style.css`
    );
  }
} else {
  import(
    `../../css/${
      location.hostname == 'localhost'
        ? 'track3'
        : location.host.split('.')[0] == 'track3s3'
        ? 'track3'
        : location.host.split('.')[0]
    }_login_style.css`
  );
}
@Component
export default class ReestrablecerPass extends Vue {
  $snotify: any;
  usuarioId: number = 0;
  fechaEnvio: Date = null;
  axios: AxiosVue;
  axiosMS: AxiosVue;
  validForm: boolean = false;
  show1: boolean = false;
  show2: boolean = false;
  passRules1: any = [];
  passRules2: any = [];
  handleError: HandleErrors = new HandleErrors();
  puedeCambiarPass: boolean = true;
  vr: Validadores = new Validadores();
  userDataChangePass: any = { contrasena1: '', contrasena2: '' };
  Controller: string = 'Cuenta';
  loadingService = new LoadingService();
  bloquearBtnAceptar: boolean = false;
  btnBloquear: boolean = true;

  constructor() {
    super();

    this.axios = new AxiosVue(ServicioProxy.Auth);
    this.axiosMS = new AxiosVue(ServicioProxy.MS);
  }

  async mounted() {
    this.passRules1 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || '* El campo debe tener al menos 8 caracteres.',
      (v: any) =>
        this.userDataChangePass.contrasena1 ==
          this.userDataChangePass.contrasena2 ||
        config.errorMensajes.passNoIguales,
      (v: any) =>
        this.vr.validaFormatoPasswordv2(v) ||
        '* Formato de contraseña incorrecto (Vea reglas de contraseña).',
    ];

    this.passRules2 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || '* El campo debe tener al menos 8 caracteres.',
      (v: any) =>
        this.userDataChangePass.contrasena1 ==
          this.userDataChangePass.contrasena2 ||
        config.errorMensajes.passNoIguales,
      (v: any) =>
        this.vr.validaFormatoPasswordv2(v) ||
        '* Formato de contraseña incorrecto (Vea reglas de contraseña).',
    ];

    try {
      this.loadingService.showLoading();
      var decodedId = atob(this.$route.params.id);
      var decodedFecha = atob(this.$route.params.fecha);
      let minutes = decodedFecha.substr(0, 2);
      let hour = decodedFecha.substr(2, 2);
      let day = decodedFecha.substr(4, 2);
      let month = decodedFecha.substr(6, 2);
      let year = decodedFecha.substr(8, 8);
      let email: string = decodedFecha.substr(12, decodedFecha.length);
      this.usuarioId = parseInt(decodedId);
      const response: any = await this.axios.http.get(
        `${this.Controller}/nombreUsuario?email=${email}`
      );
      let caducidad = response.data.caducidad;
      let horas = this.obtenerMoment(caducidad).asHours();

      this.fechaEnvio = new Date(
        parseInt(year),
        parseInt(month),
        parseInt(day),
        parseInt(hour),
        parseInt(minutes)
      );
      this.fechaEnvio.setHours(this.fechaEnvio.getHours() + horas);
      var date = new Date();
      if (this.fechaEnvio < date) {
        this.puedeCambiarPass = false;
        this.$snotify.warning(
          'Link de recuperación de contraseña ha caducado, favor solicitar nuevamente'
        );
      }
    } catch (err) {
      this.puedeCambiarPass = false;
      this.$snotify.error('Parametros de email inválidos. Redireccionando...');
      setTimeout(() => {
        this.$router.push('/login');
      }, 3000);
    } finally {
      this.loadingService.hideLoading();
    }
  }

  private obtenerMoment(valor: string): Duration {
    const regexHoras: RegExp = /^[0-9][0-9]:[0-9][0-9]:[0-9][0-9]$/;

    if (regexHoras.test(valor)) {
      return moment.duration(moment(valor, 'HH:mm:ss').format('HH:mm:ss'));
    }

    return moment.duration(moment(valor, 'DD.HH:mm:ss').format('DD.HH:mm:ss'));
  }

  changeInput() {
    var formVal: any = this.$refs;
    formVal.form.validate();
    this.btnBloquear = formVal.form.validate();
  }

  cancelar() {
    this.$router.push('/login');
  }

  actualizarPass() {
    this.loadingService.showLoading(); //Muestra Cargando

    var formVal: any = this.$refs;
    if (!this.puedeCambiarPass) {
      this.loadingService.hideLoading(); //Oculta Cargando
      this.$snotify.warning(
        'Link de recuperación de contraseña ha caducado, favor solicitar nuevamente'
      );
      return;
    }

    if (formVal.form.validate()) {
      let model: any = {
        UsuarioId: this.usuarioId,
        Contrasena: this.userDataChangePass.contrasena1,
        RepetirContrasena: this.userDataChangePass.contrasena2,
        origen: window.location.origin,
        source: 'ReestrablecerPass',
      };

      this.axiosMS.http
        .post(`track/restablecer_pass`, model)
        .then(res => {
          if (res.data.CODIGO_RESPUESTA == '1') {
            this.loadingService.hideLoading(); //Oculta Cargando
            this.$snotify.success(
              'La Contraseña ha sido actualizada de forma exitosa'
            );
            this.bloquearBtnAceptar = true;
            setTimeout(() => {
              this.$router.push('/login');
            }, 5000); //1200
          } else {
            this.$snotify.error(res.data.MENSAJE_RESPUESTA);
            this.loadingService.hideLoading(); //Oculta Cargando
          }
        })
        .catch(err => {
          this.$snotify.error('Error de conexión');
          this.loadingService.hideLoading(); //Oculta Cargando
        });

      /*this.axios.http
        .post('cuenta/changepass', model)
        .then(res => {
          this.loadingService.hideLoading(); //Oculta Cargando
          this.$snotify.success(
            'La Contraseña ha sido actualizada de forma exitosa'
          );
          this.bloquearBtnAceptar = true;
          setTimeout(() => {
            this.$router.push('/login');
          }, 5000); //1200
        })
        .catch(error => {
          this.loadingService.hideLoading(); //Oculta Cargando
          if (error.response.status == '409') {
            this.bloquearBtnAceptar = false;
            this.$snotify.warning(
              'La contraseña debe ser distinta a las últimas 3 utilizadas'
            );
          } else {
            this.handleError.showError(error);
          }
        });*/
    }
  }
}
